'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _privacyHtml = require('./privacy.html');

var _privacyHtml2 = _interopRequireDefault(_privacyHtml);

var _privacyController = require('./privacy.controller');

var _privacyController2 = _interopRequireDefault(_privacyController);

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('app.public.btms.privacy', {
		url: '/privacy',
		template: _privacyHtml2['default'],
		controller: _privacyController2['default'],
		controllerAs: 'vm'
	});
}

exports['default'] = RouteConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/privacy/privacy.route.js
 **/